import { render, staticRenderFns } from "./InstantBreadcrumb.vue?vue&type=template&id=5489b8c3&scoped=true&lang=html&"
import script from "./InstantBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./InstantBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./InstantBreadcrumb.vue?vue&type=style&index=0&id=5489b8c3&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489b8c3",
  null
  
)

export default component.exports